<script lang="ts">
	/**
	 * Shared `$listHeader` action slot: extra components (room kebab, All devices
	 * dropdown), a primary button, or the data-driven kebab (`ListActions`).
	 */
	import { listHeader } from 'src/stores/list_header';
	import { edit } from 'src/stores/ui/edit_lists';
	import ListActions from 'src/components/Lists/ListActions/ListActions.svelte';
	import { ButtonV2 } from '@Shelly/shelly-design-system';
	import { requestExitEditMode } from 'src/helpers/edit_chrome_helpers';
</script>

{#if $listHeader}
	{#if $listHeader.extraActions?.length}
		{#each $listHeader.extraActions as extra (extra.key ?? extra)}
			{@const ExtraAction = extra.component}
			<ExtraAction {...extra.props ?? {}} />
		{/each}
	{/if}

	{#if $listHeader.primaryAction}
		<ButtonV2
			variant={$listHeader.primaryAction.variant ?? 'primary'}
			size="m"
			width="full"
			icon={$listHeader.primaryAction.icon ?? ''}
			disabled={$listHeader.primaryAction.disabled ?? false}
			aria-label={$listHeader.primaryAction.ariaLabel ?? $listHeader.primaryAction.label ?? ''}
			on:click={() => {
				// Sequenced mobile exit (dissolve Finish, then tabs flow down).
				if ($edit) {
					void requestExitEditMode();
					return;
				}
				$listHeader.primaryAction?.onClick();
			}}
		>
			{#if $listHeader.primaryAction.label}
				{$listHeader.primaryAction.label}
			{/if}
		</ButtonV2>
	{:else if ($listHeader.menuItems?.length ?? 0) > 0}
		<ListActions triggerVariant="muted" />
	{/if}
{/if}
